import React, {useState} from 'react';
import { defineBlock, useInspectorControl, useEditor, useSmartProp, smartProps, EditableText } from '@smartfire/gutenberg-react';
import { PanelBody, PanelRow, SelectControl, ToggleControl } from '@wordpress/components';
import InfoIcon from '@material-ui/icons/Info';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import style from './block.module.scss';
import clsx from 'clsx';

function Inspector() {
    const [type, setType] = useSmartProp('type');
    const [closeable, setCloseable] = useSmartProp('closeable');

    return <PanelBody title='Configuration' initialOpen={true}>
            <PanelRow>
                <SelectControl
                    label="Type"
                    value={ type }
                    options={ [
                        { label: 'Info', value: 'info' },
                        { label: 'Succès', value: 'success' },
                        { label: 'Erreur', value: 'error' },
                        { label: 'Avertissement', value: 'warning' },
                    ] }
                    onChange={ setType }
                />
            </PanelRow>
            <PanelRow>
                <ToggleControl
                    label="Fermable"
                    checked={ closeable }
                    onChange={ () => setCloseable(!closeable) }
                />
            </PanelRow>
        </PanelBody>
}

function Block ({type, msg, closeable, showInspector = true, ...props}) {

    useInspectorControl(showInspector ? Inspector : () => false);
    const {isEditing} = useEditor();
    const [visible, setVisible] = useState(true);

    return <p className={clsx(style.alert, style[type], !visible && style.hidden, closeable && style.closeable, props.className && props.className)}>
        {{
            info: <InfoIcon/>,
            error: <ErrorIcon/>,
            warning: <WarningIcon/>,
            success: <CheckCircleIcon/>
        }[type]}
        <EditableText
            tagName="span"
            smartProp="msg"
            placeholder="Votre message ici..."
            allowedFormats={["core/bold", "core/italic", "core/link"]}
        />
        {closeable && <CloseIcon className={style.close} aria-label="Fermer" onClick={() => isEditing ? false : setVisible(!visible)}/>}
    </p>;
    
}

export default defineBlock({
    Block,
    smartProps: {
        type: smartProps.string.withDefault('info'), 
        msg: smartProps.string.withDefault(''),
        closeable: smartProps.bool.withDefault(true),
    },
    setup: {
        title: "Alert",
    },
});